import correction from '@/api/eschool/homework-correction'
import { baseState } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {}

export const actions = {
  fetch(context, id) {
    return correction.get(id)
  },
  store(context, data) {
    return correction.store(data)
  },
  update(context, { id, data }) {
    return correction.update(id, data)
  },
  download(context, options) {
    return correction.download({
      params: options
    })
  }
}
